module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.myReservations.length == 0 && !_vm.loading) ? _c('div', [_c('h4', {
    staticClass: "hidden-xs hidden-sm text-center"
  }, [_vm._v("No bookings available, visit "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goSitterProfileEdit()
      }
    }
  }, [_c('strong', [_vm._v("Profile Setup")])]), _vm._v(" to ensure that your profile is up to date or visit "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goDashboard()
      }
    }
  }, [_c('strong', [_vm._v("Dashboard")])]), _vm._v(" to see how your profile is doing.")]), _vm._v(" "), _c('h4', {
    staticClass: "hidden-md hidden-lg"
  }, [_vm._v("No bookings available, visit "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goSitterProfileEdit()
      }
    }
  }, [_c('strong', [_vm._v("Profile Setup")])]), _vm._v(" to ensure that your profile is up to date or visit "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goDashboard()
      }
    }
  }, [_c('strong', [_vm._v("Dashboard")])]), _vm._v(" to see how your profile is doing.")])]) : _vm._e(), _vm._v(" "), (_vm.myReservations.length > 0) ? _c('div', {
    staticClass: "hidden-lg hidden-md"
  }, [_c('button', {
    staticClass: "hidden-md hidden-lg btn btn-block btn-lg btn-info btn-title",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#filterSort"
    },
    on: {
      "click": function($event) {
        _vm.switchCollapse()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa fa-navicon"
  }), _vm._v("   " + _vm._s(_vm.summaryComp))]), _vm._v(" "), _c('div', {
    staticClass: " hidden-md hidden-lg collapse",
    staticStyle: {
      "margin-left": "0px",
      "padding-left": "0px",
      "margin-right": "0px",
      "padding-right": "0px"
    },
    attrs: {
      "id": "filterSort"
    }
  }, [_c('div', {
    staticClass: "reservationSummary"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [_c('div', {
    staticClass: "col-xs-12 remove-margins"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sort),
      expression: "sort"
    }],
    attrs: {
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.sort, "0")
    },
    on: {
      "change": function($event) {
        _vm.sort = "0"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Submitted Date")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 remove-margins"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sort),
      expression: "sort"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.sort, "1")
    },
    on: {
      "change": function($event) {
        _vm.sort = "1"
      }
    }
  }), _c('span', [_vm._v(" Start Date")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 remove-margins"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sort),
      expression: "sort"
    }],
    attrs: {
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.sort, "2")
    },
    on: {
      "change": function($event) {
        _vm.sort = "2"
      }
    }
  }), _c('span', [_vm._v(" Total Price")])])])])])]), _vm._v(" "), (!_vm.hidden) ? _c('button', {
    staticClass: "btn btn-block btn-default",
    on: {
      "click": function($event) {
        _vm.hideCompleted()
      }
    }
  }, [_vm._v("Hide Completed or Expired")]) : _c('button', {
    staticClass: "btn btn-block btn-default",
    on: {
      "click": function($event) {
        _vm.showCompleted()
      }
    }
  }, [_vm._v("Show Completed or Expired")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.myReservations.length > 0 && !_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "hidden-sm hidden-xs col-sm-4 col-xs-12 "
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [_c('div', {
    staticClass: "col-xs-12 remove-margins"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sort),
      expression: "sort"
    }],
    attrs: {
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.sort, "0")
    },
    on: {
      "change": function($event) {
        _vm.sort = "0"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Submitted Date")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 remove-margins"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sort),
      expression: "sort"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.sort, "1")
    },
    on: {
      "change": function($event) {
        _vm.sort = "1"
      }
    }
  }), _c('span', [_vm._v(" Start Date")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 remove-margins"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sort),
      expression: "sort"
    }],
    attrs: {
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.sort, "2")
    },
    on: {
      "change": function($event) {
        _vm.sort = "2"
      }
    }
  }), _c('span', [_vm._v(" Total Price")])])])])])]), _vm._v(" "), (!_vm.hidden) ? _c('button', {
    staticClass: "btn btn-block btn-info",
    on: {
      "click": function($event) {
        _vm.hideCompleted()
      }
    }
  }, [_vm._v("Hide Completed or Expired")]) : _c('button', {
    staticClass: "btn btn-block btn-info",
    on: {
      "click": function($event) {
        _vm.showCompleted()
      }
    }
  }, [_vm._v("Show Completed or Expired")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-8 col-xs-12 pull-right"
  }, _vm._l((_vm.sortedReservationsComp), function(reservation, index) {
    return _c('div', {
      key: reservation.ReservationId,
      staticClass: "wrapper "
    }, [_c('div', {
      staticClass: "media-body"
    }, [_c('div', {
      staticClass: "media-left",
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_c('img', {
      staticClass: "media-object img-responsive img-circle",
      staticStyle: {
        "min-width": "30px",
        "min-height": "30px",
        "border": "1px solid #c3c3c3"
      },
      attrs: {
        "src": reservation.CustomerProfilePic,
        "alt": "",
        "height": "30",
        "width": "30"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "media-left",
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_c('h4', {
      staticClass: "media-heading main-name",
      staticStyle: {
        "padding-bottom": "0px",
        "margin-bottom": "3px"
      }
    }, [_c('strong', [_vm._v(" " + _vm._s(reservation.CustomerName))])])]), _vm._v(" "), _c('div', {
      staticClass: "media-bottom"
    }, [_c('p', {
      staticClass: "small text-muted",
      staticStyle: {
        "padding-top": "0px",
        "margin-top": "0px",
        "padding-bottom": "0px",
        "margin-bottom": "0px"
      }
    }, [_vm._v(" Booking number: "), _c('strong', [_vm._v(" " + _vm._s(reservation.BookingNumber) + " ")])]), _vm._v(" "), _c('p', {
      staticClass: "small text-muted",
      staticStyle: {
        "padding-top": "0px",
        "margin-top": "0px",
        "padding-bottom": "0px",
        "margin-bottom": "0px"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.startDateComp(reservation)))]), _vm._v(" "), _c('span', [_vm._v("To "), _c('strong', [_vm._v(_vm._s(_vm.endDateComp(reservation)))])])]), _vm._v(" "), _c('p', {
      staticClass: "small text-muted",
      staticStyle: {
        "padding-top": "0px",
        "margin-top": "0px",
        "padding-bottom": "0px",
        "margin-bottom": "0px"
      }
    }, [_vm._v(" Submitted: "), _c('strong', [_vm._v(" " + _vm._s(_vm.sentDate(reservation.SubmittedDate)) + " ")])]), _vm._v(" "), _c('p', {
      staticClass: "small text-success",
      staticStyle: {
        "padding-top": "0px",
        "margin-top": "0px",
        "padding-bottom": "0px",
        "margin-bottom": "0px"
      }
    }, [_c('strong', [_vm._v("Starts  " + _vm._s(_vm.startDate(reservation.StartDate)) + " ")])]), _vm._v(" "), _c('p', {
      staticClass: "small text-muted",
      staticStyle: {
        "padding-top": "0px",
        "margin-top": "0px",
        "padding-bottom": "0px",
        "margin-bottom": "0px"
      }
    }, [_vm._v(" Total price: "), _c('strong', {
      staticClass: "text-success"
    }, [_vm._v(" " + _vm._s(reservation.TotalPrice) + " ")]), _vm._v(" " + _vm._s(_vm.currencyComp))]), _vm._v(" "), _c('h5', {
      staticClass: "alert text-muted",
      class: reservation.StatusClass
    }, [_c('strong', [_vm._v("Status: ")]), _vm._v(" " + _vm._s(reservation.SitterStatus))])])]), _vm._v(" "), _c('div', {
      staticClass: "media-bottom",
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('button', {
      staticClass: "btn btn-success btn-block",
      on: {
        "click": function($event) {
          _vm.goToReservation(reservation)
        }
      }
    }, [_vm._v("Go to Booking ")]), _vm._v(" "), (_vm.bookingRemovable(reservation)) ? _c('button', {
      staticClass: "btn btn-warning btn-block",
      on: {
        "click": function($event) {
          _vm.removeBooking(reservation);
          reservation.IsSitterRemoved = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    }), _vm._v(" Remove from Bookings ")]) : _vm._e(), _vm._v(" "), (reservation.IsSitterRemoved == true) ? _c('button', {
      staticClass: "btn btn-warning btn-block",
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("Removing..")]) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Filters and Sort")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Filters and Sort")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5592799e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sitters/Reservation/components/ConfirmedReservations.vue
// module id = 633
// module chunks = 2